import React from "react";

export default function Images(props){

	const {source} = props;

	return <img src={source} {...props} />

}